export default "__VITE_ASSET__D4AW1sXY__"